import styled from "styled-components";
import bannerSrc from "../../assets/images/banner-home.jpeg";
import { useFrames } from "../../hooks/useFrames";
import { usePartners } from "../../hooks/usePartners";
import { Header } from "../../components/Header";
import { Container } from "../../theme/styles";
import { Footer } from "../../components/Footer";
import { Newsletter } from "../../components/Newsletter";
import { MainBanner } from "../../components/MainBanner";
import { Link } from "react-router-dom";
import { Form } from "./components/Form";
import { Title } from "../../components/Title";
import { Frame } from "./components/Frame";
import { Post } from "./components/Post";
import { Partner } from "./components/Partner";
import { Slider } from "../../components/Slider";
import { useIsMobile } from "../../hooks/useWidth";
import { SquareInfo } from "./components/SquareInfo";
import { useHomeObjects } from "../../hooks/useHome";
import { usePageTrack } from "../../hooks/useAnalyticsPageTracker";
import { useBlogs } from "../../hooks/useBlogs";

function Home() {
  usePageTrack();

  const frames = useFrames();
  //const posts = useBlogPosts();
  const partners = usePartners();
  const {normas, decisions, dissertations, publications} = useHomeObjects();
  const blogs = useBlogs();
  
  const isMobile = useIsMobile();

  const iterateFrames = () => {
    let count = 0
    // eslint-disable-next-line array-callback-return
    return frames.map((frame, i, arr) => {
      if (frame.condition && count < 6) {
        count++;
        return (<Frame key={i} frame={frame} />)
      }
    });
  }
  return (
    <>
      <Header />
      {/* <Slider innerDots={true}> */}
        <MainBanner bannerSrc={bannerSrc} />
      {/* </Slider> */}
      <FirstContent>
        <Welcome>
          <WelcomeTitle>Sejam bem-vindos!</WelcomeTitle>
          <WelcomeText>Aqui no ONDA, reunimos e disponibilizamos um conjunto de material relevante para a compreensão, atuação e pesquisa em Direitos Autorais e suas interseções. Como pesquisadores da área, somos testemunhas das dificuldades enfrentadas e, por isso, uma de nossas principais finalidades é possibilitar que qualquer pessoa possa encontrar, em um só local, normas jurídicas, decisões judiciais, teses e demais conteúdos relevantes para diminuir suas dúvidas e aprofundar seu conhecimento.</WelcomeText>
          <WelcomeButton to="/sobre"><span>Saiba Mais</span></WelcomeButton>
        </Welcome>
        <Form />
      </FirstContent>
      <SquareList>
        <SquareInfo title="Normas Jurídicas" number={normas.total} />
        <SquareInfo title="Decisões Judiciais" number={decisions.total} />
        <SquareInfo title="Teses e Dissertações" number={dissertations.total} />
        <SquareInfo title="Publicações Selecionadas" number={publications.total} />
      </SquareList>
      {/* <Title hasSpacing={true} /> */}
      {/* <Content>
        <SliderOuter>
          <Slider>
            {iterateFrames()}
          </Slider>
        </SliderOuter>
        <FrameList>
          {iterateFrames()}
        </FrameList>
      </Content> */}
      <Content>
        <Title title={!isMobile ? "Blog do ONDA" : null} hasSpacing={true} />
        <PostsList>
          {blogs.results.slice(0,3).map((post, index, ) => <Post key={index} post={post} />)}
        </PostsList>
      </Content>
      <Content>
        <Title title="Apoiadores e Parceiros" hasSpacing={true} />
        <PartnerList>
          {partners.map((partner, index) => <Partner key={index} partner={partner} />)}
        </PartnerList>
      </Content>
      <Newsletter />
      <Footer />
    </>
  );
}

export default Home;

const FirstContent = styled(Container)`
  display: flex;
  padding: 0 36px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    padding: 0 14px;
    flex-direction: column;
  }
`;

const Content = styled(Container)`
  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    padding: 0;
  }
`;

const SquareList = styled(Container)`
  display: flex;
  justify-content: space-between;
  margin-top: 64px;

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    flex-direction: column;
  }
`;

const Welcome = styled.div`
  padding: 32px 0 0;
  max-width: 500px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    text-align: center;
    padding: 20px 0 32px;
    margin: auto;
  }
`;

const WelcomeTitle = styled.h1`
  font-size: 36px;
  color: ${({ theme }) => theme.colors.blue.dark };
  margin-bottom: 32px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    font-size: 30px;
    margin-bottom: 12px;
  }
`;

const WelcomeText = styled.p`
  color: ${({ theme }) => theme.colors.gray.darker };
  font-size: 20px;
  line-height: 1.5;
  margin-bottom: 32px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    font-size: 17px;
  }
`;

const WelcomeButton = styled(Link)`
  display: inline-block;
  background-color: ${({ theme }) => theme.colors.blue.dark };
  color: ${({ theme }) => theme.colors.pink.light };
  text-decoration: none;
  text-transform: uppercase;
  width: 256px;
  height: 80px;
  font-size: 28px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    margin: auto;
    font-size: 20px;
    width: 192px;
    height: 60px;
  }
`;

const FrameList = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 56px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
  //@media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    display: none;
  }
`;

const PostsList = styled.ul`
  display: flex;
  justify-content: center;
  list-style-type: none;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    flex-direction: column;
  }

  @media screen and (max-width: ${({ theme }) => theme.device.tiny_mobile}) {
  //@media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    width: 100%;
    max-width: ${({ theme }) => theme.device.mobile};
    overflow: auto;
    justify-content: flex-start;
    flex-direction: row;
    margin-bottom: 20px;
  }
`;

const PartnerList = styled.ul`
  display: flex;
  justify-content: center;
  list-style-type: none;
  margin-bottom: 32px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    width: 100%;
    overflow: auto;
    justify-content: flex-start;
  }
`;

const SliderOuter = styled.div`
  display: none;
  
  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
  //@media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    display: block;
  }
`;

